import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, type CaptionHit } from "./api";

function fmtTs(ms: number): string {
    const s = Math.floor(ms / 1000);
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    return h > 0
        ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`
        : `${m}:${String(sec).padStart(2, "0")}`;
}

/** Full-text search across every transcribed stream. Clicking a hit deep-links
 *  into the player at that timestamp. */
export function SearchPanel({ onJump }: { onJump: (streamKey: string, seconds: number) => void }) {
    const [q, setQ] = useState("");
    const [submitted, setSubmitted] = useState("");

    const { data: hits = [], isFetching } = useQuery({
        queryKey: ["search", submitted],
        queryFn: () => api.search(submitted),
        enabled: submitted.length > 1,
        staleTime: 60_000,
    });

    return (
        <div className="search-panel">
            <form onSubmit={e => { e.preventDefault(); setSubmitted(q.trim()); }}>
                <input
                    className="search-input"
                    placeholder="search captions across the archive… (e.g. 'under 12 reel', 'champions')"
                    value={q}
                    onChange={e => setQ(e.target.value)}
                />
                <button type="submit">search</button>
            </form>
            {submitted.length > 1 && (
                <div className="search-results">
                    {isFetching && <div className="empty">searching…</div>}
                    {!isFetching && hits.length === 0 && <div className="empty">no matches</div>}
                    {hits.map((h: CaptionHit, i) => (
                        <div
                            key={i}
                            className="search-hit"
                            onClick={() => onJump(h.stream_key, h.t0_ms / 1000)}
                            title={`${h.stream_key} @ ${fmtTs(h.t0_ms)}`}
                        >
                            <span className="search-hit-meta">
                                {h.kind === "ocr" ? "📋 card" : `▶ ${fmtTs(h.t0_ms)}`}
                                {" · "}{h.title || h.stream_key}
                            </span>
                            <span className="search-hit-text">{h.text}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
